export * from './WarningCircleFilled';
